const logic = (window as any).cupboardLogic;

export default logic;